module.exports = __webpack_public_path__ + "static/media/qr_code.4cd937bf.jpg";